import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from './constants'
import { icons } from './paths'
import type { IconProps } from './types'

/**
 * Web renderer: inline `<svg>` — no react-native-svg dependency in the
 * browser bundle. This is the default resolution; Metro picks
 * `Icon.native.tsx` instead on iOS/Android.
 */
export function Icon({ name, size = DEFAULT_ICON_SIZE, color = DEFAULT_ICON_COLOR, label, testID }: IconProps) {
  const { viewBox, paths } = icons[name]
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      data-testid={testID}
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      {paths.map((d, index) => (
        <path key={index} d={d} fill={color} />
      ))}
    </svg>
  )
}
